import React from "react";
import "../../src/App.css";

function TermsOfUse() {
  return (
    <div className="page-content">
      <h1>Terms of Use</h1>
      <p>
        <strong>Last Updated:</strong> May 13, 2025
      </p>
      <p>
        Welcome to multido.com ("we," "us," or "our"). By accessing or using our
        application ("Service"), you agree to be bound by these Terms of Use
        ("Terms"). If you do not agree to these Terms, please do not use the
        Service.
      </p>
      <h2>1. Acceptance of Terms</h2>
      <p>
        By using multido.com, you represent that you are at least 18 years old
        and have the legal capacity to enter into this agreement. These Terms
        constitute a legally binding agreement between you and multido.com.
      </p>
      <h2>2. Use of the Service</h2>
      <p>
        <strong>2.1 License:</strong> We grant you a limited, non-exclusive,
        non-transferable, revocable license to use the Service for personal,
        non-commercial purposes, subject to these Terms.
      </p>
      <p>
        <strong>2.2 Prohibited Conduct:</strong> You agree not to:
        <ul>
          <li>Use the Service for any illegal or unauthorized purpose.</li>
          <li>
            Modify, reverse-engineer, or attempt to access the source code of
            the Service.
          </li>
          <li>
            Interfere with the Service’s operation, including introducing
            viruses or malicious code.
          </li>
          <li>
            Use the Service to harass, harm, or infringe on the rights of
            others.
          </li>
          <li>
            Attempt to access data not intended for you or impersonate another
            user.
          </li>
        </ul>
      </p>
      <h2>3. User Data and Privacy</h2>
      <p>
        <strong>3.1 Data Storage:</strong> Your data (e.g., tasks, to-do lists)
        is stored locally in your browser via localStorage. We do not access
        your data unless you explicitly export and share it.
      </p>
      <p>
        <strong>3.2 Privacy:</strong> Your use of the Service is subject to our
        Privacy Policy, which is incorporated into these Terms by reference.
        Please review the Privacy Policy to understand how we handle your data.
      </p>
      <h2>4. Intellectual Property</h2>
      <p>
        All content, trademarks, and intellectual property rights in the Service
        are owned by multido.com or its licensors. You may not copy, distribute,
        or create derivative works from the Service without our prior written
        consent.
      </p>
      <h2>5. Disclaimer of Warranties</h2>
      <p>
        The Service is provided "as is" and "as available" without warranties of
        any kind, express or implied, including but not limited to warranties of
        merchantability, fitness for a particular purpose, or non-infringement.
        We do not guarantee that the Service will be uninterrupted, error-free,
        or secure.
      </p>
      <h2>6. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, multido.com, its affiliates,
        officers, directors, employees, or agents shall not be liable for any
        indirect, incidental, special, consequential, or punitive damages,
        including but not limited to loss of profits, data, or use, arising out
        of or in connection with your use of the Service, even if advised of the
        possibility of such damages. Our total liability to you for any claim
        arising from these Terms or the Service shall not exceed $100 USD.
      </p>
      <h2>7. Indemnification</h2>
      <p>
        You agree to indemnify, defend, and hold harmless multido.com and its
        affiliates, officers, directors, employees, and agents from any claims,
        liabilities, damages, losses, or expenses (including reasonable
        attorneys’ fees) arising out of your use of the Service, violation of
        these Terms, or infringement of any third-party rights.
      </p>
      <h2>8. Termination</h2>
      <p>
        We may terminate or suspend your access to the Service at our sole
        discretion, with or without notice, for any reason, including violation
        of these Terms. Upon termination, your right to use the Service will
        immediately cease. You may terminate your use of the Service at any time
        by discontinuing use and deleting your data.
      </p>
      <h2>9. Governing Law and Dispute Resolution</h2>
      <p>
        <strong>9.1 Governing Law:</strong> These Terms shall be governed by and
        construed in accordance with the laws of the State of California, USA,
        without regard to its conflict of law principles.
      </p>
      <p>
        <strong>9.2 Arbitration:</strong> Any dispute arising out of or relating
        to these Terms or the Service shall be resolved through binding
        arbitration in accordance with the rules of the American Arbitration
        Association (AAA). The arbitration shall take place in San Francisco,
        California, and shall be conducted in English. You waive any right to
        participate in a class action lawsuit or class-wide arbitration.
      </p>
      <h2>10. Changes to These Terms</h2>
      <p>
        We may update these Terms from time to time. We will notify you of
        changes by updating the "Last Updated" date at the top of this page.
        Your continued use of the Service after such changes constitutes your
        acceptance of the updated Terms.
      </p>
      <h2>11. Miscellaneous</h2>
      <p>
        <strong>11.1 Entire Agreement:</strong> These Terms, together with the
        Privacy Policy, constitute the entire agreement between you and
        multido.com regarding your use of the Service.
      </p>
      <p>
        <strong>11.2 Severability:</strong> If any provision of these Terms is
        found to be invalid or unenforceable, the remaining provisions shall
        remain in full force and effect.
      </p>
      <p>
        <strong>11.3 No Waiver:</strong> Our failure to enforce any right or
        provision of these Terms shall not constitute a waiver of such right or
        provision.
      </p>
      <h2>12. Contact Us</h2>
      <p>
        If you have questions about these Terms, please contact us at{" "}
        <a href="mailto:support@multido.com">support@multido.com</a>.
      </p>
    </div>
  );
}

export default TermsOfUse;
